import * as signalR from "@microsoft/signalr";
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import React, { Component, Fragment } from 'react';
import ImmocomContext from "../../contexts/ImmocomContext";
import PerimetreContext from "../../contexts/PerimetreContext";
import { DataContact } from '../../data/DataContact';
import { DataMessage } from '../../data/DataMessage';
import { DataMonCompte } from '../../data/DataMonCompte';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheAlarmes } from '../Fiche/FicheAlarmes';
import { FicheTchat } from '../Tchat';
import FicheEnvoiMultiple from '../Tchat/components/FicheEnvoiMultiple';

export class DetailsListCapsuleClient extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListCapsuleClientWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListCapsuleClientWithPerimetre extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        estOnline: false,
        items: [],
        itemActif: {},
        keysToUncheck: [],
        lastReceivedMessage: undefined,
        capsulesSelectionnees: [],
        statutSelectionne: 1,
        afficherPanelAlarmes: false,
        afficherPanelConversation: false,
        afficherPanelEnvoiMultiple: false,
        afficherPanelFiltres: false,
        peutGererAlarmesCapsuleClient: false,
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListCapsuleClientWithPerimetre.defaultState };
        this._styles = {
            statusIcon: {
                root: {
                    fontSize: "1rem",
                    selectors: {
                        "&.open": { color: "red" },
                        "&.pending": { color: "orange" },
                        "&.closed": { color: "green" },
                    }
                }
            },
            espaceClientActifIcon: {
                root: {
                    fontSize: "1rem",
                    selectors: {
                        "&.inactive": { color: "red" },
                        "&.active": { color: "green" },
                    }
                }
            },
            mailEnvoyeIcon: {
                root: {
                    fontSize: "1rem",
                    selectors: {
                        "&.nonEnvoye": { color: "red" },
                        "&.envoye": { color: "green" },
                    }
                }
            }
        }
        this._sortedColumn = "dateEnvoiDernierMessage";
        this._isSortedDescending = true;
        this._filtres = { ...PanelFiltres.defaultState };
        this._columns = this._getColumns();
    };

    _chargementDroitsLiesAuxAlarmes = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des droits en cours...");

        DataMonCompte._chargementDroitsLiesAuxAlarmes().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const droits = responseFetch.reponseAPIobjet;
                const peutGererAlarmesCapsuleClient = droits.peutGererAlarmesCapsuleClient;
                this.setState(
                    { peutGererAlarmesCapsuleClient },
                    () => this._columns = this._getColumns()
                );
            }
            else {
                fetchMessages(responseFetch);
                this.setState({ peutGererAlarmesCapsuleClient: false });
            }
            dismissMessage(messageId);
        });

    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;

        // Chargement silencieux dans le cas où une fenêtre de tchat est déjà ouverte
        let messageId;
        if (!this.state.afficherPanelConversation)
            messageId = addMessage("loading", "Chargement des conversations en cours...");

        const { _filtres, _sortedColumn, _isSortedDescending } = this;
        const { facteurNbreEnregistrement, pageIndex } = this.state;

        DataMessage._chargerMessagesLesPlusRecentsParContact(_filtres, _sortedColumn, _isSortedDescending, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let items = [];
                let newItems = responseFetch.reponseAPIobjet || [];

                if (this.state.pageIndex === 1) {
                    items = newItems;
                }
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = { items };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                fetchMessages(responseFetch);
                this.setState({ items: [] });
            }
            if (!!messageId) dismissMessage(messageId);
        });

    };

    _getColumns = () => {

        const getCapsuleClientActiveIconClassName = (estActivee) => {
            if (estActivee) return "active";
            else return "inactive";
        };

        const getMailEnvoyeIconClassName = (estEnvoye) => {
            if (estEnvoye) return "envoye";
            else return "nonEnvoye";
        };

        const getStatusIconClassName = (statut) => {
            switch (statut) {
                case 1: return "open";
                case 2: return "pending";
                case 3: return "closed";
            };
        };

        let columns = [
            {
                iconName: "IconSetsFlag",
                isIconOnly: true,
                key: "idStatutCapsule",
                onRender: (item) => <Icon
                    className={getStatusIconClassName(item.idStatutCapsule)}
                    iconName="CircleFill"
                    styles={this._styles.statusIcon}
                    title={item.statutCapsule}
                />
            },
            {
                key: "nomComplet",
                minWidth: 150,
                maxWidth: 150,
                name: "Contact",
            },
            {
                className: 'ms-hiddenLgDown',
                headerClassName: 'ms-hiddenLgDown',
                key: "nomOperation",
                minWidth: 300,
                maxWidth: 300,
                name: 'Opération',
            },
            {
                className: 'ms-hiddenXlDown',
                headerClassName: 'ms-hiddenXlDown',
                key: "numero",
                minWidth: 75,
                maxWidth: 75,
                name: "Lot",
            },
            {
                className: 'ms-hiddenMdDown',
                headerClassName: 'ms-hiddenMdDown',
                key: "dateReservation",
                name: "Réservé le",
            },
            {
                key: "texte",
                name: "Dernier message",
                onRender: (item) => {
                    const { piecesJointes, texte } = item;
                    const jPiecesJointes = JSON.parse(piecesJointes);
                    const hasAttachment = Array.isArray(jPiecesJointes) && jPiecesJointes.length > 0;
                    const dernierMessage = texte || (hasAttachment ? "<PJ uniquement>" : "<La conversation n'a pas démarré>");
                    return <span title={dernierMessage}>{dernierMessage}</span>;
                }
            },
            {
                key: "dateEnvoiDernierMessage",
                name: "Emis le",
            },
            {
                isIconOnly: true,
                key: "activation",
                onRender: (item) => {
                    const estActivee = item.activationCapsuleClient;
                    return <Icon
                        className={getCapsuleClientActiveIconClassName(estActivee)}
                        iconName={estActivee ? "CheckMark" : "Cancel"}
                        title={estActivee ? "Espace client activé" : "Espace client non activé"}
                        styles={this._styles.espaceClientActifIcon}
                    />;
                }
            },
            {
                isIconOnly: true,
                key: "mailEnvoye",
                onRender: (item) => {
                    const estEnvoye = item.mailCreationEspaceEnvoye;
                    return <Icon
                        className={getMailEnvoyeIconClassName(estEnvoye)}
                        iconName={estEnvoye ? "MailCheck" : "MailUndelivered"}
                        title={estEnvoye ? "Mail de création d'espace envoyé" : "Mail de création d'espace non envoyé"}
                        styles={this._styles.mailEnvoyeIcon}
                    />;
                }
            },
            {
                isIconOnly: true,
                key: "edit",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "CannedChat" }}
                        onClick={this._togglePanel("Conversation", true, item)}
                        title="Afficher la conversation"
                    />;
                }
            },
            {
                isIconOnly: true,
                key: "capsule",
                onRender: (item) => {
                    const idContactChiffre = item.idContactChiffre;
                    return <IconButton
                        iconProps={{ iconName: "RedEye" }}
                        onClick={this._visualiserCapsule(idContactChiffre, 1)}
                        title="Visualiser l'espace client"
                    />;
                }
            }
        ]

        // Pour le moment, ne pas afficher le bouton v2 en production
        if (!window.location.host.startsWith("eiffimmo.eiffage-immobilier.com"))
            columns.push({
                isIconOnly: true,
                key: "capsule",
                onRender: (item) => {
                    const idContactChiffre = item.idContactChiffre;
                    return <IconButton
                        iconProps={{ iconName: "View" }}
                        onClick={this._visualiserCapsule(idContactChiffre, 2)}
                        title="Visualiser l'espace client (v2)"
                    />;
                }
            });

        if (this.state.peutGererAlarmesCapsuleClient)
            columns.push({
                isIconOnly: true,
                key: "alarmes",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Ringer" }}
                        onClick={this._togglePanel("Alarmes", true, item)}
                        title="Gérer les alarmes"
                    />;
                }
            });

        return columns;
    };

    _getItems = () => {

        const isDisabledEnvoiMultiple = () => {
            const { capsulesSelectionnees } = this.state;

            if (!capsulesSelectionnees || capsulesSelectionnees.length <= 0) return true; // Bouton inactif si aucune capsule sélectionnée

            let toutesCapsulesActives = true;
            const groups = capsulesSelectionnees.reduce((memo, capsule) => {
                //const idOperation = `operation-${capsule.idOperation}`;
                const { idOperation } = capsule;

                if (!memo[idOperation]) memo[idOperation] = [];
                memo[idOperation].push(capsule);
                toutesCapsulesActives &= capsule.activationCapsuleClient;

                return memo;
            }, {});
            if (!toutesCapsulesActives) return true; // Bouton inactif si au moins une opération n'a pas ses capsules activées
            if (!!sessionStorage.loginCompte && sessionStorage.loginCompte.startsWith("ImmocomGestNat")) return false; // Bouton actif si utilisateur = ImmocomGestNat
            if (Object.keys(groups).length > 1) return true; // Bouton inactif si plus d'un périmètre sélectionné

            return false;
        };

        return [
            {
                disabled: this.state.capsulesSelectionnees.length <= 0,
                key: "statuts",
                text: "Modifier le statut",
                subMenuProps: {
                    items: [
                        {
                            iconProps: { iconName: "CircleFill", styles: this._styles.statusIcon, className: "open" },
                            key: "statutOuverte",
                            name: "Ouverte",
                            onClick: this._mettreAJourStatuts(1)
                        },
                        {
                            iconProps: { iconName: "CircleFill", styles: this._styles.statusIcon, className: "pending" },
                            key: "statutOuverteReponseAApporter",
                            name: "Réponse à apporter",
                            onClick: this._mettreAJourStatuts(2)
                        },
                        {
                            iconProps: { iconName: "CircleFill", styles: this._styles.statusIcon, className: "closed" },
                            key: "statutFermee",
                            name: "Fermée",
                            onClick: this._mettreAJourStatuts(3)
                        }
                    ]
                }
            },
            {
                disabled: this.state.capsulesSelectionnees.length <= 0,
                key: 'mail',
                text: 'Envoyer le mail de réservation',
                iconProps: { iconName: 'Mail' },
                onClick: this._envoyerMailContact
            },
            {
                disabled: isDisabledEnvoiMultiple(),
                key: "send",
                text: "Envoi multiple",
                iconProps: { iconName: "Megaphone" },
                onClick: this._togglePanel("EnvoiMultiple", true)
            },
        ];

    };

    _mettreAJourStatuts = (statutSelectionne) => () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Mise à jour du statut en cours...");

        let idsContactsChiffres = [];
        this.state.capsulesSelectionnees.forEach(conversation => {
            const idContactChiffre = conversation.idContactChiffre;
            if (idsContactsChiffres.indexOf(idContactChiffre) === -1)
                idsContactsChiffres.push(idContactChiffre);
        });

        DataContact._miseAJourStatutCapsules(idsContactsChiffres, statutSelectionne).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _envoyerMailContact = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Envoi des mails en cours...");

        let idsContactsChiffres = [];
        this.state.capsulesSelectionnees.forEach(conversation => {
            const idContactChiffre = conversation.idContactChiffre;
            if (idsContactsChiffres.indexOf(idContactChiffre) === -1)
                idsContactsChiffres.push(idContactChiffre);
        });

        DataContact._envoyerMailReservation(idsContactsChiffres).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _visualiserCapsule = (idContactChiffre, version) => () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Prévisualisation en cours...");

        DataContact._visualiserCapsule(idContactChiffre, version).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                window.open(responseFetch.reponseAPIobjet, "_blank");
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...filtres };
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._togglePanel("Filtres", false)();
    };

    _onRemovalDestinataire = (idContactChiffre, idReservation) => {
        this.setState({ keysToUncheck: [`${idContactChiffre};${idReservation}`] });
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onScroll = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {

        const { loginCompte } = this.props;

        this._chargementDonnees();
        this._chargementDroitsLiesAuxAlarmes();

        const origin = window.location.origin;
        let logLevel = signalR.LogLevel.None
        if (origin.includes("localhost")) logLevel = signalR.LogLevel.Debug;
        else if (origin.includes("recette")) logLevel = signalR.LogLevel.Debug;
        else if (origin.includes("preprod")) logLevel = signalR.LogLevel.Debug;

        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`/tchat`)
            .withAutomaticReconnect()
            .configureLogging(logLevel)
            .build();
        this._hubConnection.start()
            .then(() => {
                this._hubConnection.invoke("Connect", loginCompte, true);
                this.setState({ estOnline: true });
            })
            .catch((error) => console.error(error.toString()));
        this._hubConnection.on("NouveauMessage", (newMessage) => this.setState({ lastReceivedMessage: newMessage }));
        this._hubConnection.onclose((error) => this.setState({ estOnline: false }));
        this._hubConnection.onreconnecting((error) => { console.log(error); });
        this._hubConnection.onreconnected((connectionId) => { console.log("Reconnected"); });

    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { capsulesSelectionnees, estOnline, items, itemActif, keysToUncheck, lastReceivedMessage } = this.state;

        return <Fragment>

            <EUIDetailsList
                columns={this._columns}
                getKey={item => `${item.idContactChiffre};${item.idReservation}`}
                isSortedDescending={this._isSortedDescending}
                items={items}
                keysToUncheck={keysToUncheck}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                onSearch={this._onSearch}
                onSelectionChanged={items => this.setState({ capsulesSelectionnees: items })}
                onScroll={this._onScroll}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
            />

            <FicheTchat
                estOnline={estOnline}
                hubConnection={this._hubConnection}
                idContactChiffre={itemActif.idContactChiffre}
                interlocuteur={itemActif.nomComplet}
                idOperation={itemActif.idOperation}
                idReservation={itemActif.idReservation}
                isOpen={this.state.afficherPanelConversation}
                lastReceivedMessage={lastReceivedMessage}
                loginCompte={sessionStorage.getItem('loginCompte') || "ImmocomGestNat"}
                onDismiss={this._togglePanel("Conversation", false)}
                onNouveauMessage={this._chargementDonnees}
            />

            <FicheEnvoiMultiple
                destinataires={capsulesSelectionnees}
                estOnline={estOnline}
                hubConnection={this._hubConnection}
                isOpen={this.state.afficherPanelEnvoiMultiple}
                loginCompte={sessionStorage.getItem('loginCompte') || "ImmocomGestNat"}
                onDismiss={this._togglePanel("EnvoiMultiple", false)}
                onSend={this._togglePanel("EnvoiMultiple", false, {}, this._chargementDonnees)}
                onRemovalDestinataire={this._onRemovalDestinataire}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={this.state.afficherPanelFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
                onValidate={this._appliquerFiltres}
            />

            <FicheAlarmes
                afficherAlarmesLieesACapsules
                idContact={itemActif.idContact}
                idOperation={itemActif.idOperation}
                idReservation={itemActif.idReservation}
                isOpen={this.state.afficherPanelAlarmes}
                onDismiss={this._togglePanel("Alarmes", false)}
            />

        </Fragment>;
    };
};

export class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
    };

    static defaultState = {
        afficherCapsulesOuvertes: true,
        afficherCapsulesReponseAApporter: true,
        afficherCapsulesFermees: true,
        afficherCapsulesActivees: true,
        afficherCapsulesNonActivees: true,
        afficherEmailCreationEspaceEnvoye: true,
        afficherEmailCreationEspaceNonEnvoye: true,
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >
            <Label>Statuts</Label>
            <Checkbox
                label="Ouverts"
                checked={this.state.afficherCapsulesOuvertes}
                onChange={(e, isChecked) => this.setState({ afficherCapsulesOuvertes: isChecked })}
            />
            <Checkbox
                label="Ouverts (réponse à apporter)"
                checked={this.state.afficherCapsulesReponseAApporter}
                onChange={(e, isChecked) => this.setState({ afficherCapsulesReponseAApporter: isChecked })}
            />
            <Checkbox
                label="Fermés"
                checked={this.state.afficherCapsulesFermees}
                onChange={(e, isChecked) => this.setState({ afficherCapsulesFermees: isChecked })}
            />

            <Label>Activation</Label>
            <Checkbox
                label="Espaces clients activés"
                checked={this.state.afficherCapsulesActivees}
                onChange={(e, isChecked) => this.setState({ afficherCapsulesActivees: isChecked })}
            />
            <Checkbox
                label="Espaces clients non activés"
                checked={this.state.afficherCapsulesNonActivees}
                onChange={(e, isChecked) => this.setState({ afficherCapsulesNonActivees: isChecked })}
            />

            <Label>Email ouverture espace</Label>
            <Checkbox
                label="Email envoyé"
                checked={this.state.afficherEmailCreationEspaceEnvoye}
                onChange={(e, isChecked) => this.setState({ afficherEmailCreationEspaceEnvoye: isChecked })}
            />
            <Checkbox
                label="Email non envoyé"
                checked={this.state.afficherEmailCreationEspaceNonEnvoye}
                onChange={(e, isChecked) => this.setState({ afficherEmailCreationEspaceNonEnvoye: isChecked })}
            />

        </EUIPanel>;

    };

};